
import axios from 'axios'

export default {
    getIcare(){
        return axios.get('/icare')
            .then(response => {
                return response.data
            })
    },
    getIcareDataSource(params){
        return axios.get('/icare/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getIcarebyID(id){
        return axios.get('/icare/' + id)
            .then(response => {
                return response.data
            })
    },  
    getIcareDetails(id){
        return axios.get('/icare/' + id + '/details')
            .then(response => {
                return response.data
            })
    },   
    getIcareNote(id){
        return axios.get('/icare/' + id + '/get-note')
            .then(response => {
                return response.data
            })
    }, 
    createIcare(formdata){
        return axios.post('/icare', formdata)
            .then(response => {
                return response.data
            })
    },
    createIcareNote(id,formdata){
        return axios.post('/icare/' + id + '/note', formdata)
            .then(response => {
                return response.data
            })
    },
    updateIcareNote(id,icare,formdata){
        
        return axios.put('/icare/' + id + '/note/' + icare , formdata)
            .then(response => {
                return response.data
            })
    },

    deleteIcareNote(id){
        return axios.delete('/note/' + id )
            .then(response => {
                return response.data
            })
    },

    getIcareMeeting(id){
        return axios.get('/icare/' + id + '/get-meeting')
            .then(response => {
                return response.data
            })
    }, 

    createIcareMeeting(id,formdata){
        return axios.post('/icare/' + id + '/meeting', formdata)
            .then(response => {
                return response.data
            })
    },
    updateIcareMeeting(id,icare,formdata){
        return axios.put('/icare/' + id + '/meeting/' + icare, formdata)
            .then(response => {
                return response.data
            })
    },

    deleteIcareMeeting(id){
        return axios.delete('/meeting/' + id  )
            .then(response => {
                return response.data
            })
    },
   
    updateIcare(id,formdata){
        return axios.put('/icare/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateIcare(id){
        return axios.put('/icare/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateIcare(id){
        return axios.put('/icare/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    destroyIcare(id){
        return axios.delete('/icare/' + id)
            .then(response => {
                return response.data
            })
    }, 
    assign_leader_Icare(id,formdata){
        return axios.put('/icare/' + id + '/assign-as-leader', formdata)
            .then(response => {
                return response.data
            })
    },  
    
    assign_core_team_Icare(id,formdata){
        return axios.put('/icare/' + id + '/assign-as-core-team', formdata)
            .then(response => {
                return response.data
            })
    }, 
    remove_core_team_Icare(id,formdata){
        return axios.put('/icare/' + id + '/remove-core-team', formdata)
            .then(response => {
                return response.data
            })
    }, 
    remove_leader_Icare(id,formdata){
        return axios.put('/icare/' + id + '/remove-leader', formdata)
            .then(response => {
                return response.data
            })
    }, 
    remove_member_Icare(id,formdata){
        return axios.put('/icare/' + id + '/remove-member', formdata)
            .then(response => {
                return response.data
            })
    }, 
    getIcareDataSourceJoin(params){
        return axios.get('/icare-app/join/datasource', {params})
            .then(response => {
                return response.data
            })
    },   
    getJoinDetail(id){
        return axios.get('/icare-app/join/' + id)
            .then(response => {
                return response.data
            })
    },
    deactivateJoin(id){
        return axios.put('/icare-app/join/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateJoin(id){
        return axios.put('/icare-app/join/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },

}
